<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Log_urejanja-sl.json';
import en from '@/Prevodi/Log_urejanja-en.json';
import it from '@/Prevodi/Log_urejanja-it.json';
export default {
  components: {
    DropDown,
    Notification,
  },
  props: {},
  data() {
    return {
      prevodi: false,
      jadralna: [],
      motorna: [],
      izbranZapis: [],
      izbranPregled: 'jadralna',
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.Read();
  },
  computed: {},
  methods: {
    Read() {
      axios.get('./api/log/urejanja/izpis/', {withCredentials: true}).then((response) => {
        this.jadralna = response.data.jadralni;
        this.motorna = response.data.motorni;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    OpenView(podatki, id) {
      if (podatki === 'j') {
        this.izbranPregled = 'jadralna';
        this.izbranZapis = this.jadralna.filter(p => p.id === id);
      } else {
        this.izbranPregled = 'motorna';
        this.izbranZapis = this.motorna.filter(p => p.id === id);
      }

      $(this.$refs.modalIzbrisanih).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalIzbrisanih).modal('hide');
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="col-12 p-2">

    <!-- Notification -->
    <Transition name="fade">
      <Notification
          v-if="ShowNoti"
          :message="text"
          :type="types"
          @closeNotification="ShowNoti = false"
      />
    </Transition>


    <div class="edited-flights-container">

      <!-- JADRALNI LETI -->

      <section class="flight-section">

        <div class="section-header">

          <div class="section-icon glider">
            <i class="fas fa-paper-plane"></i>
          </div>

          <div>
            <h2>{{ $t('table.titleJ') }}</h2>
            <span>{{ jadralna.length }} zapisov</span>
          </div>

        </div>


        <div class="flight-list">

          <div
              class="flight-item"
              v-for="(id, index) in jadralna"
              :key="id.id"
              @click.prevent="OpenView('j', id.id)"
          >

            <div class="flight-date">
              <i class="far fa-calendar-alt"></i>
              <span>{{ id.datum_urejanja }}</span>
            </div>

            <div class="flight-user">
              <span class="label">Urejal</span>
              <strong>{{ id.urejal }}</strong>
            </div>

            <div class="flight-task">
              <span class="label">Naloga</span>
              <strong>{{ id.naloga }}</strong>
            </div>

            <div class="flight-action">
              <i class="fas fa-chevron-right"></i>
            </div>

          </div>


          <div v-if="!jadralna.length" class="empty-state">
            <i class="far fa-folder-open"></i>
            <span>Ni podatkov</span>
          </div>

        </div>

      </section>


      <!-- MOTORNI LETI -->

      <section class="flight-section mt-4">

        <div class="section-header">

          <div class="section-icon motor">
            <i class="fas fa-plane"></i>
          </div>

          <div>
            <h2>{{ $t('table.titleM') }}</h2>
            <span>{{ motorna.length }} zapisov</span>
          </div>

        </div>


        <div class="flight-list">

          <div
              class="flight-item"
              v-for="(id, index) in motorna"
              :key="id.id"
              @click.prevent="OpenView('m', id.id)"
          >

            <div class="flight-date">
              <i class="far fa-calendar-alt"></i>
              <span>{{ id.datum_urejanja }}</span>
            </div>

            <div class="flight-user">
              <span class="label">Urejal</span>
              <strong>{{ id.urejal }}</strong>
            </div>

            <div class="flight-task">
              <span class="label">Naloga</span>
              <strong>{{ id.naloga }}</strong>
            </div>

            <div class="flight-action">
              <i class="fas fa-chevron-right"></i>
            </div>

          </div>


          <div v-if="!motorna.length" class="empty-state">
            <i class="far fa-folder-open"></i>
            <span>Ni podatkov</span>
          </div>

        </div>

      </section>

    </div>

  </div>

  <!-- ODMIK OD CAPTCHE -->
  <div class='col-12 p-5'></div>
  <div class='col-12 p-2'></div>
  <!-- OBRAČUN PODROBNO -->
  <div class="modal modal-kartica" ref="modalIzbrisanih" tabindex="-1" role="dialog" v-if="prevodi">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
        <div class='d-flex justify-content-end'>
          <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
            <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
          </button>
        </div>
        <div class='modal-header'>
          <h5 class="card-title"><i class="fas fa-plane"></i> {{$t('modal.zapis')}} {{izbranZapis[0].urejal}}</h5>
        </div>
        <div class="modal-body col-12" style="overflow-y: scroll;">
          <!-- MOTORNA PODROBNO -->
          <ul class='list-group list-group-flush' v-if="izbranPregled === 'motorna'">
            <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].snamen}}
              <span v-if="izbranZapis[0].snamen !== izbranZapis[0].namen"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].namen}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].snaloga}}
              <span v-if="izbranZapis[0].snaloga !== izbranZapis[0].naloga"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].naloga}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].sreg_vleke}}
              <span v-if="izbranZapis[0].sreg_vleke !== izbranZapis[0].reg_vleke"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].reg_vleke}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].spilotM}}
              <span v-if="izbranZapis[0].spilotM !== izbranZapis[0].pilotM"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].pilotM}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.krajV')}} {{izbranZapis[0].skraj_vzleta}}
              <span v-if="izbranZapis[0].skraj_vzleta !== izbranZapis[0].kraj_vzleta"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].kraj_vzleta}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.krajP')}} {{izbranZapis[0].skraj_pristanka}}
              <span v-if="izbranZapis[0].skraj_pristanka !== izbranZapis[0].kraj_pristanka"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].kraj_pristanka}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>Block on: {{izbranZapis[0].spoletanje}}
              <span v-if="izbranZapis[0].spoletanje !== izbranZapis[0].poletanje"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].poletanje}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>Block off: {{izbranZapis[0].spristanekM}}
              <span v-if="izbranZapis[0].spristanekM !== izbranZapis[0].pristanekM"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].pristanekM}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.vZraku')}} {{izbranZapis[0].sv_zraku}}
              <span v-if="izbranZapis[0].sv_zraku !== izbranZapis[0].v_zraku"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].v_zraku}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.vizuelno')}} {{izbranZapis[0].svizuelno}}
              <span v-if="izbranZapis[0].svizuelno !== izbranZapis[0].vizuelno"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].vizuelno}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.stPristankov')}} {{izbranZapis[0].sstPristankov}}
              <span v-if="izbranZapis[0].sstPristankov !== izbranZapis[0].stPristankov"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].stPristankov}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].sopomba}}
              <span v-if="izbranZapis[0].sopomba !== izbranZapis[0].opomba"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].opomba}}</span>
                                </span>
            </li>
            <li class='list-group-item border-lorange'>{{$t('modal.datumU')}}{{izbranZapis[0].datum_urejanja}}</li>
          </ul>
          <!-- JADRALNA PODROBNO -->
          <ul class='list-group list-group-flush' v-else>
            <li class='list-group-item list-dark'>{{$t('modal.reg')}} {{izbranZapis[0].sreg_letala}}
              <span v-if="izbranZapis[0].sreg_letala !== izbranZapis[0].reg_letala"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].reg_letala}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.regV')}} {{izbranZapis[0].sreg_vleke}}
              <span v-if="izbranZapis[0].sreg_vleke !== izbranZapis[0].reg_vleke"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].reg_vleke}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].spilot}}
              <span v-if="izbranZapis[0].spilot !== izbranZapis[0].pilot"> <i class="fas fa-arrow-right"></i> &nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].pilot}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].sinstruktor}}
              <span v-if="izbranZapis[0].sinstruktor !== izbranZapis[0].instruktor"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].instruktor}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].snamen}}
              <span v-if="izbranZapis[0].snamen !== izbranZapis[0].namen"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].namen}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].snaloga}}
              <span v-if="izbranZapis[0].snaloga !== izbranZapis[0].naloga"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].naloga}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.krajV')}} {{izbranZapis[0].skraj_vzleta}}
              <span v-if="izbranZapis[0].skraj_vzleta !== izbranZapis[0].kraj_vzleta"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].kraj_vzleta}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.krajP')}} {{izbranZapis[0].skraj_pristanka}}
              <span v-if="izbranZapis[0].skraj_pristanka !== izbranZapis[0].kraj_pristanka"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].kraj_pristanka}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.poletanje')}} {{izbranZapis[0].spoletanje}}
              <span v-if="izbranZapis[0].spoletanje !== izbranZapis[0].poletanje"> <i class="fas fa-arrow-right"></i>&nbsp;
                                 <span class='text-danger'> {{izbranZapis[0].poletanje}}</span>
                             </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.casO')}} {{izbranZapis[0].scas_odklopa}}
              <span v-if="izbranZapis[0].scas_odklopa !== izbranZapis[0].cas_odklopa"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].cas_odklopa}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.pristanek')}} {{izbranZapis[0].spristanek}}
              <span v-if="izbranZapis[0].spristanek !== izbranZapis[0].pristanek"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].pristanek}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.trajanje')}}  {{izbranZapis[0].strajanje}}
              <span v-if="izbranZapis[0].strajanje !== izbranZapis[0].trajanje"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].trajanje}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.vleka')}} {{izbranZapis[0].svleka}}
              <span v-if="izbranZapis[0].svleka !== izbranZapis[0].vleka"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].vleka}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.casV')}}{{izbranZapis[0].scas_vleke}}
              <span v-if="izbranZapis[0].scas_vleke !== izbranZapis[0].cas_vleke"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].cas_vleke}}</span>
                                </span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].sopomba}}
              <span v-if="izbranZapis[0].sopomba !== izbranZapis[0].opomba"> <i class="fas fa-arrow-right"></i>&nbsp;
                                    <span class='text-danger'> {{izbranZapis[0].opomba}}</span>
                                </span>
            </li>
            <li class='list-group-item border-lorange'>{{$t('modal.datumU')}} {{izbranZapis[0].datum_urejanja}} </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.section-icon.glider {
  color: #38bdf8;
  background: rgba(56, 189, 248, .12);
}

.section-icon.motor {
  color: #a78bfa;
  background: rgba(167, 139, 250, .12);
}

</style>